import "./workout-popup-message.css";
import {useContext, useRef} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";
import TextsContext from "../../TextsContent";

const WorkoutPopupMessage = ({isShown, message, redirectLink}) => {
  console.log(redirectLink);
  const closePopupRef = useRef(null);
  const refLinkToCalendar = useRef(null);
  const navigate = useNavigate();
  const texts = useContext(TextsContext);

  // Значення за замовчуванням
  const defaultTitle = texts["workout-feedback_popup"]["workout-feedback_popup-title"];
  const defaultSubtitle = texts["workout-feedback_popup"]["workout-feedback_popup-subtitle"];
  const defaultRedirectLink = Routes.workoutPage;

  // Розпаковка масиву message
  const [title = defaultTitle, subtitle = defaultSubtitle] = message || [];

  return (
    <div className="workout-popup-container">
      <div className={`workout-popup-content ${isShown ? "shown-popup" : ""}`}>
        <img
          ref={closePopupRef}
          onClick={() => navigate(redirectLink || defaultRedirectLink)}
          className="workout-popup-close"
          src={require("./workout-popup-message-img/close.svg").default}
          width={32}
          height={32}
          alt="icon close popup"
        />
        <p className="workout-popup-title">{title}</p>
        <p className="workout-popup-subtitle">{subtitle}</p>

        {!message && !redirectLink && (
          <a
            ref={refLinkToCalendar}
            onClick={() => navigate(Routes.calendarPage)}
            className="workout-popup-link"
          >
            {texts["workout-feedback_popup"]["workout-feedback_popup-link"]}
          </a>
        )}
      </div>
    </div>
  );
};

export default WorkoutPopupMessage;
